import { useDispatch, useSelector } from "react-redux";

import { ToggleButton } from "@seneca/senekit";

import { ThemeModePreference } from "features/dark-mode/consts";
import { getPreferredThemeMode, setPreferredThemeMode } from "features/user";

import SettingLayout from "./SettingLayout";

const themeModeOptions = [
  { label: "Off", value: ThemeModePreference.LIGHT },
  { label: "OS Default", value: ThemeModePreference.SYSTEM },
  { label: "On", value: ThemeModePreference.DARK }
];

export default function DarkModeSetting() {
  const dispatch = useDispatch();
  const preferredThemeMode = useSelector(getPreferredThemeMode);

  return (
    <SettingLayout>
      {{
        title: "Dark mode",
        setting: (
          <ToggleButton
            selectedValue={preferredThemeMode}
            onChange={value => dispatch(setPreferredThemeMode(value))}
            options={themeModeOptions}
          />
        )
      }}
    </SettingLayout>
  );
}
